module.exports = __webpack_public_path__ + "static/media/createPhoneNumber.6d2d90c2.svg";